import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

const enumValuesSeparator = '|';
const typeAdd = 'add';
const typeRemove = 'remove';
const additionalInfoTypeDate = 'Date';
@Component({
    selector: 'app-additional-information-input',
    templateUrl: 'additional-information-input.component.html'
})
export class AdditionalInformationInputComponent implements OnInit {
    public static typeAdd = typeAdd;
    public static typeRemove = typeRemove;

    @Input() additionalInfo: any;
    @Input() id: string;
    @Input() model: any;
    @Output() onValueChange = new EventEmitter<{}>();
    hasEnumValues = false;
    enumValues: string[] = [];
    isTypeDate = false;

    ngOnInit() {
        this.buildEnumValues();
        this.checkIsTypeDate();
    }

    private checkIsTypeDate() {
        this.isTypeDate = this.additionalInfo.type === additionalInfoTypeDate;
    }

    private buildEnumValues() {
        if (this.additionalInfo.enumValues) {
            this.enumValues = this.additionalInfo.enumValues.split(enumValuesSeparator);
            this.hasEnumValues = this.enumValues.length > 0;
        }
    }

    notifyChange() {
        console.log("notify change info");
        this.onValueChange.emit({
            'value': this.model.value,
            'code': this.additionalInfo.code,
            'id': this.additionalInfo.id,
            'type': this.additionalInfo.type,
            'typeOfChange': this.computeTypeOfChange(),
        });
    }

    /**
     * Compute whether the value needs to be updated or removed:
     *     - removed if:
     *         - the value is from a dropdown (IE: enumValues), then it must be in the array of enumValues
     *         - the value is from an input text or date, then it can't be an empty string
     *     - added otherwise
     */
    private computeTypeOfChange(): string {
        if (!this.isTypeDate && (this.model.value === '' || this.model.value === ' ') 
            //|| (this.hasEnumValues
            //&& this.enumValues.indexOf(this.model.value) === -1)
            ) {
            return typeRemove;
        }

        return typeAdd;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/analysis/additional-information/additional-information-input/additional-information-input.component.ts